import { z } from 'zod';

export const projectDtoSchema = z.object({
  id: z.number(),
  organisationId: z.number(),
  name: z.string(),
  startDate: z.string().nullable(),
  endDate: z.string().nullable(),
  image: z.string().nullable(),
  location: z.string(),
  venue: z.string(),
  properties: z
    .object({
      avgCapacity: z.number().optional(),
      accessToPublicTransport: z.boolean().optional(),
      accessToEnergy: z.boolean().optional(),
      accessToWater: z.boolean().optional(),
      annualStaff: z.string().optional(),
      calculateOptions: z
        .object({
          includePublicAnswersForCo2: z.boolean().optional(),
        })
        .optional(),
    })
    .nullable(),
  models: z.object({
    env: z.string(),
    ess: z.string(),
  }),
});

export const getProjectsDtoSchema = z.object({
  data: z.array(projectDtoSchema),
  limit: z.number(),
  skip: z.number(),
  total: z.number(),
});

export const getProjectDtoSchema = projectDtoSchema;

export type ProjectDto = z.infer<typeof projectDtoSchema>;
